module.exports = __webpack_public_path__ + "img/iconCalculator.6433530c.svg";